import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { unwrapResult } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { fetchChannelInfoById } from '../../../../features/channels/channelsSlice';

import bb_lg_svg from '../../../assets/images/main-banner/bb_lg.svg';
import bw_lg_svg from '../../../assets/images/main-banner/bw_lg.svg';
import bb_sm_svg from '../../../assets/images/main-banner/bb_sm.svg';
import bw_sm_svg from '../../../assets/images/main-banner/bw_sm.svg';
import { useCallback } from 'react';

const ImgWithFallbackMainBanner = ({ data }) => {
  const {
    sm,
    md,
    lg,
    alt,
    bg,
    link_type,
    channel_id,
    from,
    to,
    channel_genre,
    epg_id,
    epg_collection_id
  } = data;
  const dispatch = useDispatch();
  const [link, setLink] = React.useState(null);

  const linkBuilderEpg = ({ channelId, from, to, channelGenre, epgId }) => {
    return `/channel/${channelId}/${channelGenre}?from=${from}&to=${to}&epgId=${epgId}`;
  };
  const linkBuilderCatchUp = (id) => {
    return `/detail-tv-content/${id}`;
  };

  const getChannelEpgInfo = useCallback(
    async (channelId) => {
      return await unwrapResult(await dispatch(fetchChannelInfoById(channelId)));
    },
    [dispatch]
  );

  const prepareLink = useCallback(
    async (data) => {
      switch (link_type) {
        case 'epg':
          try {
            await getChannelEpgInfo(channel_id);
            return linkBuilderEpg({
              channelId: channel_id,
              from: from,
              to: to,
              channelGenre: channel_genre,
              epgId: epg_id
            });
          } catch (error) {
            return null;
          }

        case 'catch-up':
          return linkBuilderCatchUp(epg_collection_id);
        default:
          return data.link;
      }
    },
    [channel_genre, channel_id, epg_collection_id, epg_id, from, getChannelEpgInfo, link_type, to]
  );

  useEffect(() => {
    (async () => {
      const link = await prepareLink(data);
      setLink(link);
    })();
  }, [data, prepareLink]);

  const handleClick = (e) => {
    if (!link) e.preventDefault();
    return;
  };

  return (
    <Link to={link} className="MainBanner__item" onClick={handleClick}>
      {bg ? (
        <div>
          <picture className="MainBanner__item-logo">
            <source
              media="(min-width: 768px)"
              srcSet={bg === 'white' ? bw_lg_svg : bb_lg_svg}
              alt="Бриз"
            />
            <source
              media="(max-width: 425px)"
              srcSet={bg === 'white' ? bw_sm_svg : bb_sm_svg}
              alt="Бриз"
            />
            <img className="logo" src={bg === 'white' ? bw_lg_svg : bb_lg_svg} alt="Бриз" />
          </picture>
        </div>
      ) : null}

      <picture>
        <source media="(min-width: 768px)" srcSet={lg} alt={alt} />
        <source media="(max-width: 425px)" srcSet={sm} alt={sm} />
        <source media="(min-width: 425px) and (max-width: 768px)" srcSet={md} alt={alt} />
        <img src={lg} alt={alt} />
      </picture>
    </Link>
  );
};

ImgWithFallbackMainBanner.propTypes = {
  data: PropTypes.shape({
    src: PropTypes.string,
    fallback: PropTypes.string,
    alt: PropTypes.string,
    type: PropTypes.string,
    lg: PropTypes.string,
    md: PropTypes.string,
    sm: PropTypes.string,
    link: PropTypes.string,
    bg: PropTypes.string,
    link_type: PropTypes.string,
    channel_id: PropTypes.number,
    from: PropTypes.number,
    to: PropTypes.number,
    channel_genre: PropTypes.string,
    epg_id: PropTypes.number,
    epg_collection_id: PropTypes.number
  })
};

export default ImgWithFallbackMainBanner;
